import { Navigate } from "react-router-dom";
import { lazy } from "react";

const EmissionsManagement = lazy(() => import("app/pages/cp/emissionRights/EmissionsManagement"));
const MultiEmissionBoard = lazy(() => import("app/pages/cp/analysis/MultiEmissionBoard"));
const YyRdcGoalBase = lazy(() => import("app/pages/cp/roadmap/YyRdcGoalBase"));
const EmissionsStatus = lazy(() => import("app/pages/cp/monitoring/MonitoringBoard"));
const ComprehensiveStatus = lazy(() => import("app/pages/cp/roadmap/ComprehensiveStatus"));
const Simulation = lazy(() => import("app/pages/cp/analysis/Simulation"));
const PriceAnalysis = lazy(() => import("app/pages/cp/emissionRights/PriceAnalysis"));
const MethodologyList = lazy(() => import("app/pages/cp/reductionProject/mhdlg/MethodologyList"));
const MethodologyDetail = lazy(() => import("app/pages/cp/reductionProject/mhdlg/MhdlgDetail"));
const MhethodologyInsert = lazy(() => import("app/pages/cp/reductionProject/mhdlg/MhdlgInsert"));
const ActivityDataBoard = lazy(() => import("app/pages/cp/inventory/activityData/ActiveDataDetail"));
const EvdnInsert = lazy(() => import("app/pages/cp/reductionProject/docu/evdn/EvdnInsert"));
const HistoryBoard = lazy(() => import("app/pages/cp/reductionProject/docu/DocumentBoard"));
const EvdnDetail = lazy(() => import("app/pages/cp/reductionProject/docu/evdn/EvdnDetail"));
const BusinessDetail = lazy(() => import("app/pages/cp/reductionProject/docu/business/BusinessDetail"));
const BusinessInsert = lazy(() => import("app/pages/cp/reductionProject/docu/business/BusinessInsert"));
const InventoryBoard = lazy(() => import("app/pages/cp/inventory/InventoryBoard"));
const MonitoringDetail = lazy(() => import("app/pages/cp/reductionProject/docu/monitoring/MoniDetail"));
const MonitoringInsert = lazy(() => import("app/pages/cp/reductionProject/docu/monitoring/MoniInsert"));
const ScopeEmissions = lazy(() => import("app/pages/cp/monitoring/ScopeEmissions"));
const FacilityEmissions = lazy(() => import("app/pages/cp/monitoring/FacilityEmissions"));

export const cpRouter: any = [
  { path: "cp", element: <Navigate to="inventory" replace /> },

  // 온실가스 모니터링
  { path: "/cp/monitoring", element: <EmissionsStatus /> },
  { path: "/cp/monitoring/scope", element: <ScopeEmissions /> },
  { path: "/cp/monitoring/facility", element: <FacilityEmissions /> },


  // 인벤토리 관리
  { path: "/cp/inventory", element: <InventoryBoard /> },
  { path: "/cp/inventory/activity/:scopYear/:type", element: <ActivityDataBoard /> },

  // 로드맵
  { path: "/cp/roadmap/reduceGoal/:type?", element: <YyRdcGoalBase /> },
  { path: "/cp/roadmap/status", element: <ComprehensiveStatus /> },

  // 배출권
  { path: "/cp/emiss/management", element: <EmissionsManagement /> },
  { path: "/cp/emiss/price/:type?/:grpTabIndex?/:isinCd?", element: <PriceAnalysis /> },

  // 분석
  { path: "/cp/analysis/multiEmission", element: <MultiEmissionBoard /> },
  { path: "/cp/analysis/simulation", element: <Simulation /> },

  // 온실가스 감축사업
  { path: "/cp/reduce/methodology", element: <MethodologyList /> },
  { path: "/cp/reduce/methodology/detail/:mhdlgId", element: <MethodologyDetail /> },
  { path: "/cp/reduce/methodology/insert", element: <MhethodologyInsert /> },
  { path: "/cp/reduce/docu/evdnList/insert", element: <EvdnInsert /> },
  { path: "/cp/reduce/docu/evdnList/detail/:docId", element: <EvdnDetail /> },

  // 온실가스 감축사업
  { path: "/cp/reduce/history/:type?", element: <HistoryBoard /> },
  { path: "/cp/reduce/history/business/insert", element: <BusinessInsert /> },
  { path: "/cp/reduce/history/business/detail/:docId", element: <BusinessDetail /> },
  { path: "/cp/reduce/history/monitoring/insert", element: <MonitoringInsert /> },
  { path: "/cp/reduce/history/monitoring/detail/:docId", element: <MonitoringDetail /> },
];